export default "__VITE_ASSET__ab5b9323__"